import { uuidv7 } from 'uuidv7';
import { ENV } from '../../env.js';
import { CompoundMappingType } from '../../database/schema.js';
import { zql } from '../../schema.js';
import { Status } from '../../util/schemas.js';
/**
 * Keeps the `compound_mappings` row for a resource in sync with the `machineId`
 * entered on that resource's form.
 *
 * - `machineId === undefined` → no-op (feature disabled / legacy client).
 * - `machineId === ''` → soft-deletes the mapping for this source.
 * - non-empty → inserts or revives the `(mappingType, sourceId)` mapping. The
 *   unique constraint is on `(mappingType, sourceId)` regardless of `deletedAt`,
 *   so a previously soft-deleted row is revived instead of inserting a duplicate.
 */
export async function upsertCompoundMapping(tx, input) {
    // The smart compounder feature is gated by an environment flag; when disabled the
    // machine mappings are left untouched (the resource mutators call this on every save).
    if (!ENV.SMART_COMPOUNDER_ENABLED)
        return;
    const { mappingType, sourceId, machineId, carrierType, actorId, now } = input;
    if (machineId === undefined)
        return;
    const existing = await tx.run(zql.compoundMappings.where('mappingType', '=', mappingType).where('sourceId', '=', sourceId).one());
    if (machineId === '') {
        if (!existing || existing.deletedAt !== null)
            return;
        await tx.mutate.compoundMappings.update({
            id: existing.id,
            deletedAt: now,
            deletedBy: actorId,
        });
        return;
    }
    const resolvedCarrierType = mappingType === CompoundMappingType.enum.CARRIER ? (carrierType ?? null) : undefined;
    if (existing) {
        await tx.mutate.compoundMappings.update({
            id: existing.id,
            machineId,
            ...(resolvedCarrierType !== undefined && { carrierType: resolvedCarrierType }),
            status: Status.enum.active,
            deletedAt: null,
            deletedBy: null,
            updatedAt: now,
            updatedBy: actorId,
        });
        return;
    }
    await tx.mutate.compoundMappings.insert({
        id: uuidv7(),
        mappingType,
        sourceId,
        machineId,
        ...(resolvedCarrierType !== undefined && { carrierType: resolvedCarrierType }),
        status: Status.enum.active,
        createdAt: now,
        createdBy: actorId,
    });
}
//# sourceMappingURL=utils.js.map